// normalizer utility
export const regexBank = {
  only3w: /^(.*?)www./,
  https: /^(.*?)https?:\/\//,
  globalUrlMatcher:
    /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi,
};

// utility function to normalize any urls
export const normalizer = (url: string) => {
  const insertion = 'https://';
  if (regexBank.only3w.test(url)) {
    // returns https://url
    return url.replace(regexBank.only3w, insertion);
  }
  if (regexBank.https.test(url)) {
    // returns https://url
    return url.replace(regexBank.https, insertion);
  }
  // if the url is weirdly formatted
  return insertion + url;
};

// clean pasted url
export const cleanRawUrl = (url: string) => {
  const normalized = normalizer(url);
  // returns the url with scheme (http?s://w?w?w?.) exclusion
  return normalized.replace(regexBank.https, '');
};
